import { Card, CardContent, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import { FormChange } from "@saleor/hooks/useForm";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

import { AccountSettingDetailsPageFormData } from "../AccountSettingDetailsPage";

const useStyles = makeStyles(
  theme => ({
    GeneralInformationRoot: {
      display: "grid",
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "1fr"
    },
    card: {
      overflow: "visible"
    },
    cardTitle: {
      "& span": {
        fontWeight: "500"
      }
    },
    label: {
      marginBottom: theme.spacing(1)
    },
    prop: {
      marginBottom: theme.spacing(2)
    },
    propGrid: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridRowGap: theme.spacing(1),
      gridTemplateColumns: "1fr 1fr",
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr"
      }
    },
    root: {
      overflow: "visible"
    },

    sectionTitle: {
      fontWeight: 600 as 600,
      marginBottom: theme.spacing(),
      marginTop: theme.spacing(2)
    },

    textFieldGrid: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: "1fr 1fr"
    },
    value: {
      fontSize: 20
    }
  }),
  { name: "SellerInfo" }
);

interface GeneralInfoProp {
  data: AccountSettingDetailsPageFormData;
  disabled: boolean;
  localError: { firstName: string; lastName: string; contactNo: string };
  userType: any;
  onChange: FormChange;
}

export const GeneralInfo: React.FC<GeneralInfoProp> = ({
  data,
  localError,
  onChange,
  disabled
}) => {
  const classes = useStyles({});
  const intl = useIntl();

  return (
    <>
      <div>
        <Card>
          <CardTitle
            className={classes.cardTitle}
            title={intl.formatMessage({
              defaultMessage: "General Information",
              description: "general information"
            })}
          />
          <CardContent>
            <div className={classes.GeneralInformationRoot}>
              <div className={classes.propGrid}>
                <div className={classes.prop}>
                  <TextField
                    disabled={disabled}
                    error={!!localError.firstName}
                    helperText={!!localError.firstName && localError.firstName}
                    label={intl.formatMessage(commonMessages.firstName)}
                    value={data.firstName}
                    name="firstName"
                    onChange={onChange}
                    required={true}
                    fullWidth
                  />
                </div>
                <div className={classes.prop}>
                  <TextField
                    disabled={disabled}
                    error={!!localError.lastName}
                    helperText={!!localError.lastName && localError.lastName}
                    label={intl.formatMessage(commonMessages.lastName)}
                    value={data.lastName}
                    name="lastName"
                    onChange={onChange}
                    required={true}
                    fullWidth
                  />
                </div>
                <div className={classes.prop}>
                  <TextField
                    disabled={true}
                    label={intl.formatMessage(commonMessages.email)}
                    value={data.email}
                    name="email"
                    fullWidth
                    onChange={onChange}
                  />
                </div>
                <div className={classes.prop}>
                  <TextField
                    disabled={disabled}
                    error={!!localError.contactNo}
                    helperText={!!localError.contactNo && localError.contactNo}
                    label={intl.formatMessage(commonMessages.contactNumber)}
                    value={data.contactNo}
                    name="contactNo"
                    onChange={onChange}
                    inputProps={{
                      maxLength: 12
                    }}
                    onKeyPress={event => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
export default GeneralInfo;
